import { useMutation } from "@tanstack/react-query";
import { updateBulletinStatus } from "../api/updateBulletinStatus";
import { invalidateBulletinListQuery } from "../queries/useBulletinListQuery";
import { UpdateStatusParams } from "../types";

export const useUpdateBulletinStatusMutation = () => {
  return useMutation({
    mutationFn: async ({ bulletinId, status }: UpdateStatusParams) => {
      return await updateBulletinStatus(bulletinId, status);
    },
    onSuccess: () => {
      invalidateBulletinListQuery();
    },
    onError: (e) => {
      console.error("Error occurred when updating bulletin", e);
    },
  });
};
